import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import intro291desktopCoupleImage from './img/intro291desktop-couple-image.png'
import intro291desktoplineInitials from './img/intro291desktop-line-initials.svg'
import maskOverlay from './img/intro291desktop-mask-overlay.png'
import desktopOrnament from './img/intro291desktop-ornament.svg'
import desktopPills from './img/intro291desktop-pill.svg'
import mobileLineInitials from './img/intro291mobile-line-initials.svg'
import mobileOrnament from './img/intro291mobile-ornament.svg'
import mobilePills from './img/intro291mobile-pill.svg'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro291">
      <div className="intro291mobile screen">
        <div className="main-background-JQ69hP"></div>
        <div className="container-center-horizontal">
          <div className="button-JQ69hP">
            <p
              className="site-de-casamento-e-2rUz7x"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-2rUz7x" onClick={onSkipIntro}>
              <div className="button-fHio66"></div>
              <div className="pular-introduo-fHio66">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-JQ69hP">
            <img className="pill-yIiIEz bp2-animate-enter" src={mobilePills} />
            <img
              className="ornament-yIiIEz bp2-animate-enter1"
              src={mobileOrnament}
            />
            {coupleSimplifiedName.groom && (
              <>
                <div className="e-yIiIEz bp2-animate-enter2 notranslate">
                  {coupleSimplifiedName.groom}
                </div>
              </>
            )}

            <img
              className="line-initials-yIiIEz bp2-animate-enter3"
              src={mobileLineInitials}
            />
            <div className="m-yIiIEz bp2-animate-enter4 notranslate">
              {coupleSimplifiedName.bride}
            </div>
          </div>
        </div>
      </div>
      <div className="intro291desktop screen">
        <div className="main-background-wFU2hx"></div>
        <img
          className="couple-image-wFU2hx"
          style={{ objectFit: 'cover' }}
          src={background || intro291desktopCoupleImage}
        />
        <img className="mask-overlay-wFU2hx" src={maskOverlay} />
        <div className="container-center-horizontal">
          <div className="button-wFU2hx">
            <p
              className="site-de-casamento-e-rqnGwM"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-rqnGwM" onClick={onSkipIntro}>
              <div className="button-DGNPRO"></div>
              <div className="pular-introduo-DGNPRO">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-wFU2hx">
            <img className="pill-r3GvGE bp1-animate-enter" src={desktopPills} />
            <img
              className="ornament-r3GvGE bp1-animate-enter1"
              src={desktopOrnament}
            />
            {coupleSimplifiedName.groom && (
              <>
                <h1 className="e-r3GvGE bp1-animate-enter2 notranslate">
                  {coupleSimplifiedName.groom}
                </h1>
              </>
            )}

            <img
              className="line-initials-r3GvGE bp1-animate-enter3"
              src={intro291desktoplineInitials}
            />
            <div className="m-r3GvGE bp1-animate-enter4 notranslate">
              {coupleSimplifiedName.bride}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
